/**
 * In-app navigation helpers for detail pages.
 *
 * Prefer `history.back()` when this session already visited another SPA route
 * (preserves browser history and any restored list state). Fall back to a
 * known parent path for deep links / first paint.
 */

let currentPath: string | null = null;
let previousPath: string | null = null;

/** Called by the router on every resolved route change. */
export function noteRouteChange(path: string): void {
  const normalized = path || "/";
  if (currentPath === normalized) return;
  previousPath = currentPath;
  currentPath = normalized;
}

/** True when an earlier in-app route exists in this session. */
export function canUseHistoryBack(): boolean {
  return previousPath !== null && previousPath !== currentPath;
}

/**
 * Go back via browser history when safe; otherwise navigate to `fallbackPath`.
 */
export function navigateBack(navigate: (path: string) => void, fallbackPath: string): void {
  if (canUseHistoryBack()) {
    window.history.back();
    return;
  }
  navigate(fallbackPath);
}
